import { render, staticRenderFns } from "./Redemption.vue?vue&type=template&id=9ad37cc0&scoped=true&"
import script from "./Redemption.vue?vue&type=script&lang=js&"
export * from "./Redemption.vue?vue&type=script&lang=js&"
import style0 from "./Redemption.vue?vue&type=style&index=0&id=9ad37cc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ad37cc0",
  null
  
)

export default component.exports